<template>
  <div class="flex flex-col">
    <div>
      <div
        class="w-full h-full mockup-wrapper flex-1 mt-4 columns-2 md:columns-3 xl:columns-4 min-[1920px]:columns-5 min-[2160px]:columns-6 min-[2560px]:columns-7 space-y-2 gap-x-2"
      >
        <template
          v-for="(mockup, index) in mockupsToDisplay"
          :key="`${mockup.id}-${index}-${$route?.params?.subcategory}`"
        >
          <div
            v-if="
              index &&
              index === PROMOTION_GAP_3D &&
              promoMockup3D &&
              route.params.subcategory == 't-shirt'
            "
            class="w-full overflow-hidden"
          >
            <router-link
              :to="`/3d/edit/${promoMockup3D.id}`"
              class="flex cursor-pointer rounded-md overflow-hidden relative bg-background-highlight max-h-full h-full"
            >
              <AdvanceImage
                :src="
                  promoMockup3D?.object?.['preview-thumbnail'] ||
                  promoMockup3D?.object?.['thumbnail']
                "
                class="w-full object-cover aspect-[4/5] z-10"
                img-class="w-full h-full aspect-[4/5]"
                container-class="w-full h-full aspect-[4/5]"
              />
              <!-- <div class="absolute bottom-2.5 right-2">
                <Icon class="text-white" width="20" icon="bi:badge-3d-fill" />
              </div>
              <div
                class="absolute top-5 left-0 right-0 flex flex-col items-center justify-center z-0"
              >
                <span class="text-xs text-white tracking-widest">
                  CREATE IN
                </span>
                <img :src="Badge3d" alt="3d badge" class="mt-4 w-[140px]" />
              </div> -->
            </router-link>
            <router-link
              v-if="
                isSaleLive &&
                salesData?.banner &&
                index &&
                index === PROMOTION_GAP_3D - 1
              "
              to="/pricing"
              class="flex cursor-pointer rounded-md overflow-hidden mb-2 relative bg-gray-50"
            >
              <AdvanceImage class="w-full h-full" :src="salesData?.banner" />
            </router-link>
          </div>
          <div
            v-if="getPromoVideoMockup(index)"
            :key="`${mockup.id}-${index}-${$route?.params?.subcategory}`"
            class="w-full overflow-hidden"
          >
            <router-link
              :to="{
                name: 'video-mockup-editor',
                params: { id: getPromoVideoMockup(index).id },
              }"
              class="flex cursor-pointer rounded-md overflow-hidden relative flex-col gap-y-1"
            >
              <AdvanceVideo
                :src="getPromoVideoMockup(index)?.video?.url"
                autoplay
                loop
                muted
                :aspect-ratio="
                  getPromoVideoMockup(index)?.video?.size?.width /
                    getPromoVideoMockup(index)?.video?.size?.height || 0.8
                "
                class="rounded overflow-hidden cursor-pointer h-full w-full"
                video-class="h-full w-full object-fit-cover"
                container-class="h-full w-full"
              ></AdvanceVideo>
              <div class="text-xs leading-4 text-left truncate text-[#6E6E6E]">
                {{ getPromoVideoMockup(index)?.prompt }}
              </div>
              <div
                class="absolute top-2 right-2 rounded-2xl bg-[#30343B] flex gap-x-0.5 items-center px-2 py-0.5"
              >
                <span class="text-white text-xs font-medium">VIDEO</span>
                <img :src="BadgeMax" alt="BadgeMax" class="w-3 h-3" />
              </div>
            </router-link>
          </div>
          <div v-if="mockup?.mockup" class="w-full overflow-hidden relative">
            <RouterLink
              :to="{ name: 'mockup-editor', params: { id: mockup?.id } }"
              class="flex flex-col gap-1 cursor-pointer"
            >
              <div
                v-if="checkBundle(mockup.bundleId)"
                class="overflow-hidden h-ful w-full flex justify-center"
              >
                <div
                  class="bg-[#151515] absolute w-[calc(100%-40px)] h-28 rounded-md"
                ></div>
                <div
                  class="bg-[#2E2E2E] mt-1.5 absolute h-28 w-[calc(100%-28px)] rounded-md"
                ></div>
                <Mock
                  class="mt-3 rounded-md overflow-hidden"
                  :data="{ design, color }"
                  :config="mockup"
                />
              </div>
              <Mock
                v-else
                class="rounded-md overflow-hidden block w-full"
                :data="{ design, color }"
                :config="mockup"
              />
              <div class="text-xs leading-4 text-left truncate text-[#6E6E6E]">
                {{ formatName(mockup.name) }}
              </div>
            </RouterLink>
          </div>
        </template>
      </div>
    </div>
    <ClientOnly>
      <div
        v-if="showPagination && !hidePagination"
        class="flex justify-center py-3 md:mb-3"
      >
        <Pagination
          v-slot="{ page }"
          v-model:page="currentPage"
          :total="pageLength * mockupOnPage"
          :items-per-page="mockupOnPage"
          :sibling-count="1"
          show-edges
          :default-page="currentPage"
          class="overflow-hidden"
        >
          <PaginationList v-slot="{ items }" class="flex items-center gap-1">
            <PaginationPrev @click="loadPrevPage" />
            <template v-for="(item, index) in items">
              <PaginationListItem
                v-if="item.type === 'page'"
                :key="index"
                :value="item.value"
                as-child
              >
                <Button
                  class="w-10 h-10 p-0"
                  :variant="item.value === page ? 'default' : 'outline'"
                  @click="goToPage(item.value)"
                >
                  {{ item.value }}
                </Button>
              </PaginationListItem>
              <PaginationEllipsis v-else :key="item.type" :index="index" />
            </template>
            <PaginationNext
              :disabled="currentPage === pageLength"
              @click="loadNextPage"
            />
          </PaginationList>
        </Pagination>
      </div>
    </ClientOnly>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onServerPrefetch, watch } from "vue";
import Mock from "./Mockup.vue";
import placeHolderImage from "../../assets/designPlaceholder.png";
import { useMockupStore } from "@/datastore/module/mockup.js";
import {
  Pagination,
  PaginationEllipsis,
  PaginationList,
  PaginationListItem,
  PaginationNext,
  PaginationPrev,
} from "../../components/ui/pagination";
import { Button } from "../../components/ui/button";
import { formatName } from "../../util/common.util.js";
import { useSubscription } from "@vueuse/rxjs";
import {
  closeModals,
  resetPagination,
  closePricingDrawer,
} from "@/lib/utils.js";
import { useRoute, useRouter } from "vue-router";
import AdvanceImage from "@/components/common/AdvanceImage.vue";
import { isSaleLive, salesData } from "@/views/pricing/misc/sales.js";
import { useVideoMockupsStore } from "@/datastore/module/videoMockup.js";
import { Icon } from "@iconify/vue";
import AdvanceVideo from "@/components/common/AdvanceVideo.vue";
import Badge3d from "@/assets/3D.png";
import BadgeMax from "@/assets/badge/max-simple.svg";
import { promoMockup3D } from "@/views/mockup/listing/misc/utils.js";
import { storeToRefs } from "pinia";

const PROMOTION_GAP_3D = 19;
const mockupOnPage = 24;
const PROMOS_PER_PAGE = 7;
const videoPlacementIndexes = [4, 7, 8, 11, 15, 19, 22];

const props = defineProps({
  mockups: {
    type: Array,
    default: () => [],
  },
  design: {
    type: String,
    default: placeHolderImage,
  },
  color: {
    type: Object,
    default: () => {},
  },
  hidePagination: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const router = useRouter();
const store = useMockupStore();
const { data } = storeToRefs(store);
const storeVideo = useVideoMockupsStore();

const currentPage = ref(route?.query?.page || 1);

const bundle = computed(() => store.bundle);
const filteredData = computed(() => store.filteredData);
const filteredVideo = computed(() => storeVideo.filteredData);
const mockupsToDisplay = computed(() => {
  return props.mockups?.length
    ? props.mockups.slice(0, mockupOnPage)
    : data.value?.slice(0, mockupOnPage);
});

const pageLength = computed(() => {
  return props.mockups?.length
    ? Math.ceil(props.mockups?.length / mockupOnPage)
    : Math.ceil(filteredData.value?.length / mockupOnPage);
});

const showPagination = computed(() => {
  return pageLength.value > 1;
});

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const goToPage = async (pageNumber) => {
  currentPage.value = pageNumber;
  if (Number(currentPage.value) >= 2) {
    await store.fetchData(route.name, route.params);
  }
  setTimeout(() => {
    const currentQuery = { ...route?.query };
    currentQuery.page = pageNumber;
    router.replace({ query: { ...currentQuery } });
  }, 100);
  scrollToTop();
};

useSubscription(
  closeModals.subscribe(() => {
    closePricingDrawer.next();
  }),
);

useSubscription(
  resetPagination.subscribe(() => {
    currentPage.value = 1;
    goToPage(1);
  }),
);

onServerPrefetch(async () => {
  await store.fetchData(route.name, route.params, 0, mockupOnPage);
  await storeVideo.fetchData(route.params, 0, 10);
});

const loadNextPage = () => {
  if (currentPage.value) {
    goToPage(currentPage.value);
  }
  scrollToTop();
};

const loadPrevPage = () => {
  if (currentPage.value) {
    goToPage(currentPage.value);
  }
  scrollToTop();
};

const checkBundle = (id) => {
  return bundle.value[id]?.length > 1 ? true : false;
};

const getPromoVideoMockup = (index) => {
  const videoCount = filteredVideo.value?.length;

  const positionInSeries = videoPlacementIndexes.indexOf(index);
  if (positionInSeries === -1) return null;

  const paginatedIndex = (positionInSeries + PROMOS_PER_PAGE * 0) % videoCount;
  return filteredVideo.value?.[paginatedIndex] ?? null;
};

watch(
  () => route.query.page,
  (newPage) => {
    currentPage.value = parseInt(newPage as string) || 1;
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped></style>
